import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { BsPlusCircleFill } from 'react-icons/bs';
import { CiEdit } from 'react-icons/ci';
import { RiDeleteBin5Line } from 'react-icons/ri';

interface chapterstruc{
    id:number;
    name:string;
}
const Chapter = () => {

    const api = process.env.REACT_APP_API_URL as string;
    const openModal = (postId: number) => {
        setSelectedUserId(postId);
        setIsModalOpen(true);
      };
    
      // Function to close modal and clear the post ID
      const closeModal = () => {
        setSelectedUserId(null);
        setIsModalOpen(false);
      };
const[chapterdata, setChapterdata] = useState<chapterstruc[]>([]);
 const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);



useEffect (()=>{
    const fetch = async ()=>{
        try{

            const response = await axios.get(`${api}/auth/chapter`);
            setChapterdata(response.data.data);

        }
        catch(error){
   
            //console.log('error fetching point', error);
        }
    }
    fetch();
})
  return (
      <div>
           {/* news header  */}
           <div
             className="flex justify-between items-center sticky top-0 z-10 px-2  w-full left-0 right-0 h-[74px]"
             style={{
               WebkitBackdropFilter: "blur(22px)",
               backdropFilter: "blur(22px)",
             }}
           >
             <div
               className="flex justify-between cursor-pointer h-[45px] px-2 py-2 bg-[#FDBC12] text-darkblue items-center rounded-lg gap-2"
               onClick={() => openModal(-1)}
             >
               <BsPlusCircleFill /> <h6>Add New</h6>
             </div>
     
             
     
             
           </div>
     
           <div>
             {isModalOpen && (
               <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                 <div className="bg-white rounded-lg w-[50%] h-auto">
                   {/* Close button */}
                   {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
              X
            </button> */}
                   <Modal pointId={selectedUserId} onClose={closeModal} />
                 </div>
               </div>
             )}
             <div className="px-2 py-3 overflow-y-auto">
            <table className="table-auto w-full border-collapse border bg-white border-gray-300">
       <thead className="bg-darkblue text-white">
         <tr>
           <th className="border-y border-y-gray-300 px-4 py-2 text-left">Name</th>
           
           <th className="border-y border-y-gray-300 px-4 py-2 text-left">value</th>
           <th className="border-y border-y-gray-300 px-4 py-2 text-left"></th>
         </tr>
       </thead>
       <tbody>
         {chapterdata.length > 0 ? (
           chapterdata.map((item) => (
             <tr key={item.id} className="border border-gray-300">
               <td className=" px-4 py-2 flex gap-3">      
                   <h3 className="font-semibold">{item.name}</h3>
                   
               </td>
               
               <td className="border-y border-y-gray-300 px-4 py-2">
                 <div className="flex gap-4">
                   <button
                     className="flex items-center gap-2 px-3 py-1 border border-darkblue text-darkblue rounded-lg hover:bg-darkblue hover:text-white"
                     onClick={() => openModal(item.id)}
                   >
                     <CiEdit />
                   </button>
                   
                 </div>
               </td>
             </tr>
           ))
         ) : (
           <tr>
             <td colSpan={7} className="text-center py-4">
               Loading...
             </td>
           </tr>
         )}
       </tbody>
     </table>
     </div>
           </div>
         </div>
   )
}


interface ModalProps {
  pointId?: number | null;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ pointId, onClose }) => {
  const api = process.env.REACT_APP_API_URL as string;
  const [formData, setFormData] = useState({
    name: "",
  });

  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (pointId != -1) {
      const fetchPost = async () => {
          try {
              const response = await axios.get(
                `${api}/auth/chapter/${pointId}`
              );
            
              // Debugging the entire response
              //console.log('Full response:', response);
              //console.log('Response data of point:', JSON.stringify(response.data, null, 2));
            
              // Check if the server wraps data in an object with `data` property
              const serverData = response.data.data || response.data; // Adjust for server response
            
              // Handle array data
              const datafromarray = Array.isArray(serverData) ? serverData[0] : serverData;
            
              if (!datafromarray) {
                console.error('No point data found');
                return;
              }
            
              // Destructure fields
              const {name } = datafromarray;
            
              //console.log('Type:', type);
              //console.log('Value:', data);
            
              // Update form state
              setFormData({
                name,
              });
            } catch (err: any) {
              console.error('Error fetching point:', err.response?.data || err.message);
            }
            
      };
      fetchPost();
    }
  }, [pointId]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  

 

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate fields
    if (!formData.name) {
      setError("All fields are required.");
      return;
    }

    const data = new FormData();
data.append("name", formData.name);

//console.log('type: ', formData.type)
//console.log('data: ', formData.data)

try {
  const endpoint = pointId !== -1 
    ? `${api}/auth/chapter/${pointId}` 
    : `${api}/auth/chapter`;
  
  const method = pointId !== -1 ? "put" : "post";

  const response = await axios({
    method,
    url: endpoint,
    data,
    headers: { "Content-Type": "application/json" },
  });

  // //console.log(
  //   pointId !== -1 ? "Point updated successfully" : "Point created successfully"
  // );

  // Optionally log the server response for debugging
  //console.log("Server response:", response.data);

  onClose(); // Close modal or form
  window.location.reload(); // Reload the page
} catch (err: any) {
  console.error("Error submitting point:", err.response?.data || err.message);
  setError("Failed to submit the point. Please try again.");
}
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white lg:w-1/2 md:w-[75%] w-[96%] p-6 rounded shadow relative  overflow-y-auto">
        <form onSubmit={handleSubmit} className="space-y-4 grid ">
          <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-2">
            <div>
              <label className="text-[#030303] font-medium"> Chapter Name</label>
              <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter Chapter Name..."
                  className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[14px]"
                  required
                />
              </div>
            </div>
           
            
          </div>
          

          <div className=" flex justify-between">
            {/* Date */}

            <div className="flex items-center">
              {/*Cancel form button*/}
              <button
                className="mt-[22px] mx-[10px] border-[#94A2B8] border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-semibold"
                onClick={onClose}
              >
                Cancel
              </button>
              {/* Submit Button */}
              <button
                type="submit"
                className="mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold"
                disabled={
                  !formData.name
                }
              >
                {pointId != -1 ? "Update Chapter" : "Add Chapter"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default Chapter